import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	anyTransitionLabel: {
		id: 'accessible-workflow-diagram.diagram.global-transition.any-transition-label',
		defaultMessage: 'Any',
		description:
			'Message that indicates this transition can be used from "Any" status in the workflow.',
	},
});
